$(".video-timer video").each(function(index, el) {
	const $this = $(el);

	$this.on("timeupdate", function(event){
		onTrackedVideoFrame(this.currentTime, $(this).closest('.video-timer'));
	});
});

const handleActiveState = (seconds, $parent) => {
	const $imageContainerLarge = $parent.closest('.monitor').find('.monitor__image-large');
	const $imageContainer = $parent.closest('.monitor').find('.monitor__image');

	if (seconds < 3) {
		$imageContainerLarge
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');		
	}

	if (seconds >= 2.6) {
		$imageContainer
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');		
	}
}

const onTrackedVideoFrame = (currentTime, $parent) => {
	let minutes = Math.floor((currentTime % 3600)/60);
	let seconds = Math.floor(currentTime % 60);

	handleActiveState(currentTime, $parent);

	seconds = seconds > 9 ? seconds : `0${seconds}`;
	$parent.find('.video__current-time').text(`${minutes}:${seconds}`);
}
